<template>
  <div class="viewDetial" v-if="hackReset">
    <!-- 订单详情弹框 -->
    <a-modal title="体检套餐详情" :width="900" :visible="visible" :footer="null" @cancel="handleCancel" :maskClosable="false">
      <div class="viewDetial-tiem">
        <div>
          <s-table ref="tables" :columns="columns" :data="loadData" :rowKey="(record) => record.mediId">
          </s-table>
        </div>
      </div>
    </a-modal>
  </div>

</template>

<script>
  import {STable} from '@/components';
  import {medComboProjectPage} from '@/api/modular/interhospital/subIndividual/subIndividual';

  /**
   * @Description: 体检套餐详情
   */
  export default {
    components: {STable},

    data() {
      return {
        parameter: {},

        visible: false,
        loadData: parameter => {
          return new Promise(async (resolve, reject) => {
            const res = await medComboProjectPage(Object.assign(parameter, this.parameter));
            resolve(res.data)
          })
        },
        // 表头
        columns: [
          {title: '创建时间', align: 'center', dataIndex: 'createTime'},
          {title: '套餐编号', align: 'center', dataIndex: 'projectNum'},
          {title: '检查科室', align: 'center', dataIndex: 'departmentName'},
          {title: '套餐名称', align: 'center', dataIndex: 'projectName'},
          {title: '性别限定', align: 'center', dataIndex: 'gender'},
          {title: '金额（元）', align: 'center', dataIndex: 'projectPrice'},
          {title: '套餐状态', align: 'center', dataIndex: 'status'},
        ],
        hackReset: true,
      }
    },

    created() {
    },

    methods: {
      // 初始化方法
      view(item) {
        console.log(item);

        /*if (item.id != this.parameter.comboId) {
          this.parameter.comboId = item.id;
        }*/
        if (item.comboNum != this.parameter.comboId) {
          this.parameter.comboId = item.comboNum;
        }
        this.visible = true;
      },

      // 关闭页面的时候通过v-if重组页面，防止组件缓存不调用接口
      handleCancel() {
        this.visible = false;
        this.hackReset = false;

        this.$nextTick(() => {
          this.hackReset = true;
        })
      },
    },
  }
</script>

<style lang="less" scoped>
  .viewDetial-tiem {
    margin-bottom: 10px;
  }

  .viewDetial-header {
    display: flex;

    .viewDetial-title {
      flex: 7;
    }

    .viewDetial-btn {
      flex: 3;
      padding: 4px 0;
    }
  }

  .viewDetial-title {
    height: 40px;
    line-height: 40px;
    font-family: "PingFang SC ", "PingFang SC", sans-serif;
    font-weight: 600;
    font-style: normal;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.847);
    margin-bottom: 20px;

    .viewDetial-title-notes {
      font-weight: 400;
      font-size: 13px;
      color: rgba(127, 127, 127, 0.847058823529412);
      margin-left: 15px;
    }
  }

  .viewDetial-tiem-type {
    height: 40px;
    line-height: 40px;
    background-color: #fff;
    color: rgb(51, 51, 51);
    background-color: #d7d7d7;
    padding: 0 20px;
    border-radius: 5px;

  }

  /deep/ .s-table-tool {
    display: none;
  }

  .viewDetial-logistics {
    display: flex;

    .viewDetial-logistics-item {
      flex: 1;
      width: 290px;
      max-width: 290px;
    }

    .viewDetial-logistics-map {
      flex: 1;

      #MapContainer {
        height: 310px;
        width: 100%;
      }
    }

  }

  .totalPrice {
    line-height: 30px;
    padding: 0 15px 0 30px;
  }
</style>
